import { ColorPicker } from 'material-ui-color';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { REDUX_ACTIONS } from '../../../shared/config/constants';
import styles from './styles';

const ColorPickerHeader = React.memo(function ColorPickerHeader({ field }) {
  const classes = styles();
  const dispatch = useDispatch();
  const { columnsColorDefinition } = useSelector((state) => state.currentUser.preferences.datachartSettings);
  const [selectedColor, setSelectedColor] = useState(
    columnsColorDefinition[field] ??
      '000'
  );

  useEffect(() => {
    if (columnsColorDefinition[field] === selectedColor) return;

    const newColor = { [field]: selectedColor };
    dispatch({
      type: REDUX_ACTIONS.SET_DATA_CHART_PREFERENCES,
      payload: {
        columnsColorDefinition: {
          ...columnsColorDefinition,
          ...newColor,
        },
      },
    });
  }, [selectedColor]);

  useEffect(() => {
    if (columnsColorDefinition[field] !== selectedColor) {
      setSelectedColor(columnsColorDefinition[field] ?? '000');
    }
  }, [columnsColorDefinition, field]);

  return (
    <ColorPicker
      className={classes.pickerControl}
      size={5}
      borderWidth={0}
      value={`#${selectedColor}`}
      key={`colorPicker_${field}`}
      deferred
      hideTextfield
      onChange={(evt) => {
        setSelectedColor(evt.hex);
      }}
    />
  );
});

ColorPickerHeader.propTypes = {
  field: PropTypes.string,
};

export default ColorPickerHeader;
